/* eslint-disable angular/file-name */
angular.module('zc.master.zcliteInvoices')
  .controller('MasterZcliteAgencyInvoicesListController', MasterZcliteAgencyInvoicesListController);

MasterZcliteAgencyInvoicesListController.$inject = ['$scope', '$translate', 'Page', 'SearchFilter', 'agencies', 'invoices'];
function MasterZcliteAgencyInvoicesListController($scope, $translate, Page, SearchFilter, agencies, invoices) {
  const vm = this;
  const maxPeriod = moment().format('YYYY-MM');

  Page.setBodyClass('');
  $translate('masterZclite.agencyInvoices.list.liteAgencyList').then(function(translation) {
    return Page.setTitle(translation);
  });

  vm.agencies = agencies;
  vm.invoices = invoices;

  vm.getInvoiceSites = getInvoiceSites;
  vm.isCreatedBeforeCurrentMonth = isCreatedBeforeCurrentMonth;
  vm.isViewingLatestMonth = isViewingLatestMonth;
  vm.nextMonth = nextMonth;
  vm.prevMonth = prevMonth;
  vm.setSortProp = setSortProp;

  vm.filters = SearchFilter.resolveFromLocation();
  SearchFilter.setComponentDefaults('masterZcliteAgencyInvoices', {
    sort_prop: {
      default: 'currentMonthInvoice.invoice_price'
    },
    sort_direction: {
      default: 'desc'
    },
    current_month: {
      // month of search
      default: moment().format('YYYY-MM')
    },
  });

  $scope.$on('$destroy', () => {
    SearchFilter.removeComponentDefaults('masterZcliteAgencyInvoices');
  });

  // TODO: move to ngInit but this is not a component so cant...
  updateData();


  // ========== functions ============

  function updateData() {
    _.each(vm.agencies, agency => {
      agency.invoices = _.filter(vm.invoices, monthlyInvoices =>
        monthlyInvoices[0].agency_name === agency.name
      )[0];
      agency.currentMonthInvoice = getInvoiceForMonth(agency.invoices, vm.filters.current_month);

      const hoursInDay = 24;
      const currentElapsedHoursInMonth = (moment().date() - 1) * hoursInDay + moment().hour();
      const totalHoursInMonth = moment().daysInMonth() * hoursInDay;
      const restOfMonthMultiplier = 1 / currentElapsedHoursInMonth * totalHoursInMonth;
      if(isViewingLatestMonth()) {
        agency.currentMonthInvoice.projectedInvoicePrice = _.sumBy(
          agency.currentMonthInvoice.sites,
          site => {
            const projectedAmount = site.invoice_price * restOfMonthMultiplier;
            // Take the maximum invoice amount into account
            return _.min([projectedAmount, site.max_invoice]);
          }
        );
      }
    });

    sortData();
    calculateTotals();
  }

  function sortData() {
    // do the sorting
    const sortDirectionReverse = (vm.filters.sort_direction === 'desc');

    vm.agencies = _.sortBy(vm.agencies, d => _.get(d, vm.filters.sort_prop));
    if(sortDirectionReverse) {
      vm.agencies.reverse();
    }

    SearchFilter.updateComponentDefaults('masterZcliteAgencyInvoices');
  }

  // calculate totals
  function calculateTotals() {
    vm.totalInvoicePrice = _.sumBy(
      vm.agencies,
      agency => agency.currentMonthInvoice.invoice_price
    );
    vm.totalInvoicePriceTaxExcluded = _.sumBy(
      vm.agencies,
      agency => agency.currentMonthInvoice.invoice_price_tax_excluded
    );
    vm.totalInvoiceSites = _.sumBy(
      vm.agencies,
      agency => getInvoiceSites(agency.currentMonthInvoice.sites).length
    );
    vm.totalSites = _.sumBy(
      vm.agencies,
      agency => agency.currentMonthInvoice.sites.length
    );
    vm.projectedInvoicePrice = _.sumBy(
      vm.agencies,
      agency => agency.currentMonthInvoice.projectedInvoicePrice
    );
  }

  function setSortProp(key) {
    if(vm.filters.sort_prop === key) {
      if(vm.filters.sort_direction === 'desc') {
        vm.filters.sort_direction = 'asc';
      } else {
        vm.filters.sort_direction = 'desc';
      }
    } else {
      vm.filters.sort_prop = key;
      vm.filters.sort_direction = 'desc';
    }
    updateData();
  }

  function getInvoiceForMonth(agencyInvoices, monthToGet) {
    let invoice = _.find(agencyInvoices, d => d.month === monthToGet);
    if(!invoice) {
      invoice = {
        invoice_price: 0,
        invoice_price_tax_excluded: 0,
        sites: []
      };
    }
    return invoice;
  }

  function getInvoiceSites(agencySites) {
    return _.filter(agencySites, site => site.invoice_price > 0);
  }

  function isCreatedBeforeCurrentMonth(agency) {
    return moment(agency.created_at).isBefore(moment(vm.filters.current_month));
  }

  function isViewingLatestMonth() {
    return moment(vm.filters.current_month).isSame(moment().startOf('month'));
  }

  function nextMonth() {
    if(vm.filters.current_month >= maxPeriod) return;
    vm.filters.current_month = moment(vm.filters.current_month, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    updateData();
  }

  function prevMonth() {
    vm.filters.current_month = moment(vm.filters.current_month, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
    updateData();
  }

}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_agency_invoices/list.js